module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productDetailContent"
  }, [_c('div', {
    staticClass: "page-item"
  }, [_c('div', {
    staticClass: "content productshow"
  }, [_c('div', {
    staticClass: "content-left"
  }, [_c('div', {
    staticClass: "infobox"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('div', {
    staticClass: "mainimg"
  }, [_c('img', {
    attrs: {
      "src": _vm.big,
      "alt": _vm.product.name
    }
  }), _vm._v(" "), (_vm.defaultImg == _vm.big && _vm.productVideo != '' && _vm.productVideo != null) ? _c('div', {
    staticClass: "playbtn",
    on: {
      "click": function($event) {
        return _vm.showVideo(_vm.productVideo, _vm.product.name + '视频')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "imglist"
  }, [_c('ul', _vm._l((_vm.small), function(item, i) {
    return (i < 6) ? _c('li', {
      key: i,
      class: _vm.big == item ? 'on' : '',
      on: {
        "click": function($event) {
          return _vm.setBig(i)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item,
        "alt": _vm.product.name
      }
    })]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "pDetail t"
  }, [_vm._v("\r\n                                " + _vm._s(_vm.product.name) + "\r\n                            ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pDetail price"
  }, [_c('div', {
    staticClass: "price1"
  }, [_vm._v("原价："), _c('span', [_vm._v("￥" + _vm._s(_vm.sellPrice.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "price2"
  }, [_vm._v("现售价："), _c('span', [_vm._v("￥" + _vm._s(_vm.settlementPrice.toFixed(2)))])])]), _vm._v(" "), _vm._l((_vm.frontendPropertyInfo), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "pDetail sku"
    }, [_c('div', {
      staticClass: "t"
    }, [_vm._v("\r\n                                  " + _vm._s(item.name) + "：\r\n                                ")]), _vm._v(" "), _c('ul', _vm._l((item.propertyDetails), function(p, j) {
      return _c('li', {
        key: j,
        class: (p.disable == true ? 'disableSpec ' : '') + (p.current == true ? 'on' : ''),
        on: {
          "click": function($event) {
            p.disable == true ? _vm.selAttr1() : _vm.selAttr(i, j)
          }
        }
      }, [_vm._v("\r\n                                        " + _vm._s(p.name) + "\r\n                                    ")])
    }), 0)])
  }), _vm._v(" "), _c('div', {
    staticClass: "pDetail num"
  }, [_c('div', {
    staticClass: "t"
  }, [_vm._v("\r\n                                    数量：\r\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "numbox"
  }, [_c('span', {
    on: {
      "click": _vm.reduceNum
    }
  }, [_vm._v("\r\n                                        -\r\n                                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.num),
      expression: "num"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.num)
    },
    on: {
      "change": _vm.changeNum,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.num = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.addNum
    }
  }, [_vm._v("\r\n                                        +\r\n                                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "t"
  }, [_vm._v("\r\n                                  库存剩余(" + _vm._s(_vm.stockNum) + ")\r\n                                ")])]), _vm._v(" "), _vm._m(1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "desbox"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "navbox"
  }, [_c('div', {
    staticClass: "navbox-content ql-editor",
    domProps: {
      "innerHTML": _vm._s(_vm.productMsg)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content-right"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("商城热卖")]), _vm._v(" "), _c('ul', _vm._l((_vm.productList), function(item, i) {
    return _c('li', {
      key: i
    }, [_c('img', {
      attrs: {
        "src": item.defaultImage
      },
      on: {
        "click": function($event) {
          return _vm.toDetail(item.id)
        }
      }
    }), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "price1"
    }, [_vm._v("\r\n                                        ￥" + _vm._s(item.settlementPrice.toFixed(2)) + "\r\n                                    ")]), _vm._v(" "), _c('span', {
      staticClass: "price2"
    }, [_vm._v("\r\n                                        ￥" + _vm._s(item.sellPrice.toFixed(2)) + "\r\n                                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "ptitle",
      on: {
        "click": function($event) {
          return _vm.toDetail(item.id)
        }
      }
    }, [_vm._v("\r\n                                    " + _vm._s(item.name) + "\r\n                                ")])])
  }), 0)])])]), _vm._v(" "), _c('videoShow', {
    ref: "videoShow"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pDetail tags"
  }, [_c('span', [_vm._v("经典")]), _vm._v(" "), _c('span', [_vm._v("潮流")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pDetail btns"
  }, [_c('a', {
    staticClass: "buy"
  }, [_vm._v("立即购买")]), _vm._v(" "), _c('a', {
    staticClass: "addcar"
  }, [_vm._v("加入购物车")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [_c('ul', [_c('li', {
    staticClass: "on"
  }, [_vm._v("商品详情")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51fd571f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/goods/waitAuditGoodsDetails.vue
// module id = 764
// module chunks = 2